module.exports = __webpack_public_path__ + "img/42.2c0ce94.jpg";